import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import "./styles.css";

const qc = new QueryClient();

// Service Worker: only register in PROD; in dev, unregister any leftovers.
if ("serviceWorker" in navigator) {
  if (import.meta.env.PROD) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/service-worker.js").catch(()=>{});
    });
  } else {
    navigator.serviceWorker.getRegistrations?.().then(regs => {
      regs.forEach(r => r.unregister());
      console.info("[Lysten] DEV mode: unregistered", regs.length, "service worker(s)");
    });
  }
}

// Debug banner so we know this bundle actually loaded
console.log("%c[Lysten] Frontend boot",
  "background:#8B5FFF;color:white;padding:2px 6px;border-radius:6px",
  { mode: import.meta.env.MODE, prod: import.meta.env.PROD, time: new Date().toISOString() }
);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
